var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotificationActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1484_16863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7 18.7536L22.4733 18.5536C21.8305 17.9805 21.2676 17.3235 20.8 16.6003C20.289 15.6022 19.983 14.5118 19.9 13.3936V10.1003C19.9044 8.344 19.2674 6.64658 18.1085 5.32691C16.9497 4.00724 15.3488 3.15617 13.6067 2.93359V2.07359C13.6067 1.83755 13.5129 1.61118 13.346 1.44427C13.1791 1.27736 12.9527 1.18359 12.7167 1.18359C12.4806 1.18359 12.2543 1.27736 12.0874 1.44427C11.9204 1.61118 11.8267 1.83755 11.8267 2.07359V2.94693C10.1002 3.18555 8.51866 4.04176 7.37503 5.357C6.2314 6.67223 5.60316 8.35736 5.60668 10.1003V13.3936C5.52371 14.5118 5.2177 15.6022 4.70668 16.6003C4.24726 17.3218 3.69347 17.9788 3.06001 18.5536L2.83334 18.7536V20.6336H22.7V18.7536Z",
    fill: "url(#paint0_linear_1484_16863)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0134 21.333C11.0718 21.7556 11.2812 22.1428 11.6029 22.423C11.9246 22.7032 12.3368 22.8576 12.7634 22.8576C13.19 22.8576 13.6022 22.7032 13.9238 22.423C14.2455 22.1428 14.4549 21.7556 14.5134 21.333H11.0134Z",
    fill: "#C2C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1484_16863",
    x1: 1.37429,
    y1: 1.18359,
    x2: 22.2794,
    y2: 21.0756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1484_16863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.800018)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationActive);
export default __webpack_public_path__ + "static/media/icon_notification_active.323ab3ec24e77f7a81738187cfe3798c.svg";
export { ForwardRef as ReactComponent };